// Totals for the Master Summary cards.
//
// The project-summary endpoint (Crm::Project::Building.master_summary_object on
// the API) returns four rows, and the first one — "ON GOING PROJECTS" — is not a
// bucket of its own: it is already the sum of the three rows below it. Adding
// every row, which is what the cards used to do, reported exactly double.
//
// So callers split that roll-up row out with `splitRollupRow` and hand it to the
// card as `totalRow`; cards whose rows really are disjoint groups pass none.

export const ROLLUP_ROW_ID = 1;

export const summaryTotals = (rows = [], totalRow = null) => {
  const source = totalRow ? [totalRow] : rows;

  return {
    count:  source.reduce((sum, row) => sum + (Number(row.number) || 0), 0),
    weight: source.reduce((sum, row) => sum + (Number(row.weight) || 0), 0),
  };
};

export const splitRollupRow = (data = []) => {
  const all = (data || []).map((row) => ({
    id: row.id, name: row.name, number: row.number, weight: row.weight,
  }));
  const totalRow = all.find((row) => row.id === ROLLUP_ROW_ID) || null;

  return { rows: all.filter((row) => row !== totalRow), totalRow };
};
